import store from '@/store'
import {
  connectionService,
  TAG_RACE_TIMEOUT,
  TAG_FIND_URI,
  TAG_ENTITIES_FIND_URI,
  RACE_TIMEOUT
} from '@leapsight/styleguide'

export default {
  getTags() {
    return new Promise(resolve => {
      const p1 = new Promise(resolve => {
        setTimeout(resolve, TAG_RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        const connection = store.getters['authState/connection']
        const account_id = connectionService.getAccountId()
        const args = [{ account_id }]
        const kwArgs = connectionService.createkwArgs()
        const options = {
          timeout: TAG_RACE_TIMEOUT
        }
        kwArgs.query_spec = { _p: 'account_id,id,label,color' }

        connection.session.call(TAG_FIND_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          resolve(error)
        })
    })
  },
  entitiesFind({ tagId, projection }) {
    return new Promise((resolve, reject) => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        const connection = store.getters['authState/connection']
        const args = [tagId]
        const kwArgs = connectionService.createkwArgs()
        const options = {}
        kwArgs.query_match = { type: 'mrn:' + projection }
        kwArgs.query_spec = { _limit: 1000 }

        connection.session
          .call(TAG_ENTITIES_FIND_URI, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
